module.exports = __webpack_public_path__ + "static/NeuzeitSLTStd-Book-68dea4d41ea0cad83b5c39c45be89c10.ttf";